import { useEffect, useState } from "react";
import { DialogContent, DialogTitle, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BREAKPOINT, WIDTH } from "../../../constants/breakpoints";

//import general components
import BaseDialog from "../base-dialog/base-dialog";

//import images and icons
import { Add } from "iconsax-react";

//import styles
import "./base-sort.scss";

function BaseSort({ open, setOpen, optionList, handleChange, defaultValue, setRequestFlag, setPage }) {
    //general variables
    const { t } = useTranslation();

    //set value radio button for sort
    const [sortValue, setSortValue] = useState(optionList[0].value);
    const handleSortChange = event => {
        const { value } = event.target;
        setSortValue(value);
        handleChange(value);
        setOpen(false);
        if (setRequestFlag) {
            setRequestFlag(true);
            setPage?.(1);
        }
    };

    //default value
    useEffect(() => {
        if (defaultValue) {
            setSortValue(defaultValue);
        }
    }, [defaultValue]);

    return (
        <>
            {WIDTH > BREAKPOINT ? (
                <Grid className="base-sort" container item xs={12} md="auto" columnGap={1}>
                    <Grid className="base-sort__title" container item xs="auto" alignItems="center">
                        <span>{t("sort")}</span>
                    </Grid>
                    <RadioGroup name="controlled-radio-buttons-group" value={sortValue} onChange={handleSortChange} row>
                        {optionList.map((option, index) => {
                            return (
                                <FormControlLabel
                                    key={option.value}
                                    value={option.value}
                                    control={<Radio sx={{ display: "none" }} />}
                                    label={option.label}
                                    className={`base-sort__label ${sortValue === option.value ? "active" : ""}`}
                                />
                            );
                        })}
                    </RadioGroup>
                </Grid>
            ) : (
                <BaseDialog title={t("sort")} open={open} handleClose={() => setOpen(false)} top="auto" icon="close">
                    <DialogContent dividers={true}>
                        <Grid container item xs={12}>
                            <RadioGroup
                                name="controlled-radio-buttons-group"
                                value={sortValue}
                                onChange={handleSortChange}
                                row
                                sx={{ width: { xs: "100%", md: "auto" } }}
                            >
                                {optionList.map((option, index) => {
                                    return (
                                        <Grid key={option.value} container item xs={12}>
                                            <FormControlLabel
                                                value={option.value}
                                                control={<Radio sx={{ "&.Mui-checked": { color: "var(--primary-color)" } }} />}
                                                label={option.label}
                                            />
                                        </Grid>
                                    );
                                })}
                            </RadioGroup>
                        </Grid>
                    </DialogContent>
                </BaseDialog>
            )}
        </>
    );
}

export default BaseSort;
